import * as React from "react";

function ToggleCollapseIcon(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M12.7721 15.6652L18.6902 9.77913C18.7883 9.68245 18.8663 9.56743 18.9194 9.44071C18.9726 9.31398 19 9.17805 19 9.04077C19 8.90348 18.9726 8.76756 18.9194 8.64083C18.8663 8.5141 18.7883 8.39908 18.6902 8.30241C18.4939 8.10872 18.2284 8 17.9517 8C17.675 8 17.4095 8.10872 17.2133 8.30241L11.976 13.4501L6.79114 8.30241C6.59488 8.10872 6.32941 8 6.05269 8C5.77596 8 5.51049 8.10872 5.31423 8.30241C5.21526 8.39872 5.13653 8.51358 5.08259 8.64032C5.02864 8.76706 5.00058 8.90318 5 9.04077C5.00058 9.17836 5.02864 9.31447 5.08259 9.44121C5.13653 9.56796 5.21526 9.68281 5.31423 9.77913L11.2323 15.6652C11.3304 15.7708 11.4495 15.855 11.582 15.9126C11.7145 15.9703 11.8575 16 12.0022 16C12.1469 16 12.2899 15.9703 12.4224 15.9126C12.5549 15.855 12.674 15.7708 12.7721 15.6652Z"
        fill="#3B3B3B"
      />
    </svg>
  );
}

export default ToggleCollapseIcon;
